import { render, staticRenderFns } from "./view_seminar.vue?vue&type=template&id=29c35dae"
import script from "./view_seminar.vue?vue&type=script&lang=js"
export * from "./view_seminar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports